import { ChevronDownIcon } from '@chakra-ui/icons';
import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { BRANCH_LOCAL_STORAGE_KEY, CLINIC_SETTINGS } from 'src/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var branchOptions = Object.values(CLINIC_SETTINGS);

var BranchSelector = function BranchSelector() {
  var branchChangeHandler = function branchChangeHandler(branch) {
    localStorage.setItem(BRANCH_LOCAL_STORAGE_KEY, branch.BRANCH_CODE);
    window.location.reload();
  };

  return /*#__PURE__*/_jsxs(Menu, {
    e2eid: "components_BranchSelector_Menu",
    children: [/*#__PURE__*/_jsx(MenuButton, {
      "data-role": "menu-button",
      "aria-label": "select branch",
      e2eid: "components_BranchSelector_MenuButton",
      children: /*#__PURE__*/_jsx(IconButton, {
        size: "sm",
        icon: /*#__PURE__*/_jsx(ChevronDownIcon, {
          boxSize: 6,
          e2eid: "components_BranchSelector_ChevronDownIcon"
        }),
        "aria-label": "select branch",
        variant: "ghost",
        e2eid: "components_BranchSelector_IconButton"
      })
    }), /*#__PURE__*/_jsx(MenuList, {
      borderRadius: "md",
      e2eid: "components_BranchSelector_MenuList",
      children: branchOptions.map(function (item, idx) {
        return /*#__PURE__*/_jsx(MenuItem, {
          onClick: function onClick() {
            return branchChangeHandler(item);
          },
          e2eid: "components_BranchSelector_MenuItem",
          children: item.BANNER_TITLE
        }, idx);
      })
    })]
  });
};

export default BranchSelector;